const SEO = ({
    title,
    description,
    keywords,
    ogImage = '/og-image.jpg',
    ogType = 'website',
    twitterCard = 'summary_large_image'
}) => {
    const siteTitle = 'Donzi Art Academy';
    const fullTitle = title ? `${title} | ${siteTitle}` : siteTitle;

    // Update document head
    document.title = fullTitle;

    // Update meta tags
    const metaTags = [
        { name: 'description', content: description },
        { name: 'keywords', content: keywords },
        { property: 'og:title', content: fullTitle },
        { property: 'og:description', content: description },
        { property: 'og:type', content: ogType },
        { property: 'og:image', content: ogImage },
        { property: 'og:site_name', content: siteTitle },
        { name: 'twitter:card', content: twitterCard },
        { name: 'twitter:title', content: fullTitle },
        { name: 'twitter:description', content: description },
        { name: 'twitter:image', content: ogImage },
        { name: 'viewport', content: 'width=device-width, initial-scale=1' },
        { name: 'theme-color', content: '#000000' }
    ];

    // Update existing meta tags or create new ones
    metaTags.forEach(tag => {
        const existingTag = document.querySelector(`meta[${tag.name ? 'name' : 'property'}="${tag.name || tag.property}"]`);
        if (existingTag) {
            existingTag.setAttribute('content', tag.content);
        } else {
            const newTag = document.createElement('meta');
            if (tag.name) newTag.setAttribute('name', tag.name);
            if (tag.property) newTag.setAttribute('property', tag.property);
            newTag.setAttribute('content', tag.content);
            document.head.appendChild(newTag);
        }
    });

    // Update canonical URL
    const canonicalLink = document.querySelector('link[rel="canonical"]') || document.createElement('link');
    canonicalLink.setAttribute('rel', 'canonical');
    canonicalLink.setAttribute('href', window.location.href);
    if (!document.querySelector('link[rel="canonical"]')) {
        document.head.appendChild(canonicalLink);
    }

    return null; // This component doesn't render anything
};

export default SEO; 